module.exports = __webpack_public_path__ + "img/Tutorial_Resultlist.f21d3c8e.jpg";